import { useSelector } from 'react-redux'

import type { RetailOrderLineItem } from '~/api/graphql/generated/types'
import { getBundleFixedPriceFromLineItem } from '~/components/dashboard/invoices/invoiceUtils'
import { getIsSetBundlePriceEnabled } from '~/store/reducers/constants'
import type { InvoiceLineItem } from '~/types'
import {
  getIsRetailOrderLineItem,
  isGroupedInvoiceItem,
} from '~/utils/invoiceUtils'

export const useHasGroupedParentWithFixedPrice = (
  parentItem?: InvoiceLineItem | RetailOrderLineItem,
): boolean => {
  const isBundlePriceEnabled = useSelector(getIsSetBundlePriceEnabled)

  return Boolean(
    isBundlePriceEnabled &&
    parentItem &&
    isGroupedInvoiceItem(parentItem) &&
    !getIsRetailOrderLineItem(parentItem) &&
    getBundleFixedPriceFromLineItem(parentItem as InvoiceLineItem) != null,
  )
}
